import { render, staticRenderFns } from "./Exam.vue?vue&type=template&id=a54310b8&scoped=true"
import script from "./Exam.vue?vue&type=script&lang=js"
export * from "./Exam.vue?vue&type=script&lang=js"
import style0 from "./Exam.vue?vue&type=style&index=0&id=a54310b8&prod&lang=scss&scoped=true"
import style1 from "./Exam.vue?vue&type=style&index=1&id=a54310b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54310b8",
  null
  
)

export default component.exports